export default __webpack_public_path__ + "static/Muli-Regular-1e6db0b8495f75b8dcc99d690271fd24.ttf";